// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___1IP6d","open":"open___1Q9It","table":"table___G3IUK"};